import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-login-utente',
  standalone: true,
  templateUrl: './login-utente.component.html',
  styleUrls: ['./login-utente.component.scss'],
  imports: [ReactiveFormsModule, MdbFormsModule, MdbValidationModule,
    RouterModule, CommonModule
  ]
})
export class LoginUtenteComponent implements OnInit {

  form: FormGroup;
  messageKO: string = '';
  divKO = false;

  constructor(private service : UtenteService, @Inject(Router) private router: Router) {
    this.form = new FormGroup({
      password: new FormControl(null, { validators: [Validators.required,Validators.minLength(7)], updateOn: 'submit' }),
      email: new FormControl(null, { validators: [Validators.required,Validators.email], updateOn: 'submit' }),
    });
  }

  get password(): AbstractControl {
    return this.form.get('password')!;
  }
  get email(): AbstractControl {
    return this.form.get('email')!;
  }

  login(dati:any){
    if(window.location.hostname == 'localhost'){
      dati['email'] = 'info@tradingfrattale.it'
      dati['password'] = 'provaci123'
    }
    this.service.loginUtente(dati).subscribe(
      (ut:any)=>{
        console.log(ut)
        if(ut['res']=='ko'){
          console.log(ut)
          this.divKO = true
          this.messageKO = ut['msg']
        }else{
          this.service.setUtente(ut['utente'])
          console.log(this.service.getUtente())
          let u = this.service.getUtente()
          this.service.setIsLogin(u)
          this.router.navigate(['/'])
        }
      }
    )
  }
  onSubmit(): void {
    this.form.markAllAsTouched();
    this.login(this.form.value)
  }

  ngOnInit(): void {
  }

}
